import React, { FC } from "react";
import { useDispatch } from "react-redux";
import { ChargeQuote } from "@containers/PayPerLead/interface";
import { Button } from "@shared/components";
import { actions } from "@containers/PayPerLead/store";

import { Price } from "./Price";

export interface QuoteProps {
  id: number;
  data: ChargeQuote;
  coupon: string | null;
}

export const Quote: FC<QuoteProps> = ({ id, data, coupon }) => {
  const dispatch = useDispatch();
  const removeCoupon = () => {
    dispatch(actions.setSubscriptionDiscount.request({ id, coupon: null }));
  };

  return (
    <>
      {data.subtotal !== data.total && (
        <>
          <div className="subtotal">
            <div className="label">Subtotal</div>
            <div className="amount disabled">
              <Price amount={data.subtotal} />
            </div>
          </div>

          {!!coupon && (
            <div className="subtotal">
              <div className="label">
                Coupon&nbsp;
                {coupon && (
                  <>
                    {coupon}&nbsp;
                    <Button buttonStyle="clear" onClick={removeCoupon}>
                      Disable
                    </Button>
                  </>
                )}
              </div>
              <div className="amount">
                {data.discount > 0 ? (
                  <>
                    -<Price amount={data.discount} />
                  </>
                ) : (
                  "$0"
                )}
              </div>
            </div>
          )}

          {!!data.credits && (
            <div className="subtotal">
              <div className="label">FlikWallet Balance</div>
              <div className="amount">
                -<Price amount={data.credits} />
              </div>
            </div>
          )}
        </>
      )}

      <div className="total">
        <div className="label">Total</div>
        <div className="amount">
          <Price amount={data.total} />
        </div>
      </div>
    </>
  );
};
